<!-- EmptyRouteView.vue -->
<template>
  <router-view />
</template>
